import styled from 'styled-components'
import { breakpoints } from 'src/utils/styles/global-styles'

export const Container = styled.div`
  background-color: ${(props) => props.theme.skyblue};
  padding: 24px 100px;
  text-align: center;
  width: 100%;
  margin-bottom: ${(props) => (props.theme.frame ? '0px' : '24px')};
  @media (max-width: 1400px) {
    padding: 16px 60px;
  }
  @media (max-width: ${breakpoints.xl}px) {
    padding: 16px 8px;
  }
  @media (max-width: ${breakpoints.l}px) {
    width: 101vw;
    margin-left: -22%;
  }
  @media (max-width: ${breakpoints.m}px) {
    margin-top: 16px;
    margin-left: -6%;
  }
  @media (max-width: ${breakpoints.s}px) {
    margin-top: 16px;
  }
`
export const VipHeadline = styled.h1`
  font-family: 'FilsonProBold';
  font-size: 18px;
  line-height: 140%;
  letter-spacing: 2.5px;
  margin: 0px 0px 2px 0px;
  @media (max-width: ${breakpoints.s}px) {
    letter-spacing: 2px;
    letter-spacing: 3.2px;
    font-size: 16px;
  }
`
export const VipSubHeadline = styled.h2`
  font-family: 'FilsonPro';
  font-size: 18px;
  line-height: 140%;
  letter-spacing: 0.28px;
  margin: 0px;
  @media (max-width: ${breakpoints.s}px) {
    font-size: 14px;
  }
`
export const Title = styled.h2`
  font-family: 'FilsonPro';
  font-size: 26px;
  line-height: 140%;
  margin: 0px;
  @media (max-width: ${breakpoints.s}px) {
    font-size: 24px;
  }
`
export const Deal = styled.p`
  font-family: 'FilsonProBook';
  font-size: 13px;
  line-height: 14px;
  margin: 0px auto;
  width: 320px;
  @media (max-width: ${breakpoints.s}px) {
    font-size: 11px;
    max-width: 260px;
  }
`
